import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import { Link, useLocation } from 'react-router-dom';
import { StateEnrollmentParams } from '../../../types/enrollment/enrollment';
import toast from 'react-hot-toast';
import { AddRounded, ArrowForwardRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded, EditRounded } from '@mui/icons-material';
import { actionDeleteEnrollment, actionFetchEnrollmentUsers } from '../../../actions/enrollment';
import { ImageBuffer, Loader, PageHeader, Pagination } from '../../../components';
import { EnrollmentListHeader } from '../../../utils/constants';
import moment from 'moment';

import './viewEnrollment.css'
import { emptyDisplay } from '../../../assets';

interface DeletePostParams {
  detailId: string;
  firstName: string;
}

const ViewEnrollment = () => {
  const dispatch                                              = useDispatch<AppDispatch>();
  const location                                              = useLocation();
  const modalNavRef                                           = useRef<HTMLDivElement | null>(null);
  const [openSubMegaMenu, setOpenSubMegaMenu]                 = useState<string | null>(null);
  const [toggleResult, setToggleResult]                       = useState<boolean>(false);
  const searchParams                                          = new URLSearchParams(location.search);
  const page                                                  = searchParams.get("page") || 1
  const {isLoading, getAllEnrollmentUsers, numberOfPages, totalNumber}  = useSelector((state: RootState) => state.enrollmentList);
  const [allPosts, setAllPosts]                               = useState<StateEnrollmentParams[]>(getAllEnrollmentUsers);
  const [isOpen, setIsOpen]                                   = useState<{ [key: number]: boolean }>({})
  // const [page, setPage]                                    = useState<number>(1);

  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }
  
  const handleDeletePost = ({detailId, firstName}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete this user ${firstName}?`)) {
      // Dispatch the deletePost action here
      dispatch(actionDeleteEnrollment({id: detailId}))
        .then(() => {
          setAllPosts(allPosts.filter(post => post._id !== detailId));
          // Show success toast after successfully deleting the post
          toast.success('Enrollment deleted successfully');
        })
        .catch((error) => {
          // Handle any errors that occur during the deletion process
          toast.error('Error deleting enrollment: ' + error.message);
        });
    }
  };
  
  useEffect(() => {
    dispatch(actionFetchEnrollmentUsers({page})); // You can pass the page number as needed
  }, [dispatch, page]);

  if(!allPosts.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
        <div className='empty-profile-card-header'>
          <span><DoNotDisturbAltRounded /></span>
          <h1> No Enrollments Found </h1>
        </div>
        {/* <Button buttonWrapper="button-wrapper" linkButton linkTo="/users/create-user" linkClass="link-wrapper" linkName="create user" /> */}
      </div>
    </>
  )

  return (
    <>
      <title>Enrollment</title>
      <PageHeader title="Enrollment" description="Welcome to the Enrollment Page" download="Download Report" />
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Enrollment</h3>
          {/* <Button buttonWrapper="button-wrapper" linkButton linkTo="users/create-users" linkClass="link-wrapper" linkName="View all" /> */}
        </div>
        
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {EnrollmentListHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPosts.map((detail, index) => {
                const postImage = `${process.env.REACT_APP_BACKEND_POSTS_IMAGE_URL}${detail?.selectedFile}` || emptyDisplay;
              return (
                <tr key={index}>
                  <td data-cell="image">
                  <div className="table-image">
                    {isLoading ? <Loader /> : (
                      <ImageBuffer src={postImage} alt='user img' index={index} />
                    )}
                  </div>
                </td>
                  <td data-cell="first name">{detail?.firstName}</td>
                  <td data-cell="last name">{detail?.lastName}</td>
                  <td data-cell="sex">{detail?.sex}</td>
                  <td data-cell="email address">{detail?.emailAddress}</td>
                  <td data-cell="phone number">{detail?.phoneNumber}</td>
                  <td data-cell="resume">
                    <a className="about-main-read-more-btn-cover" href={`${detail.resume}`} target="_blank" rel="noopener noreferrer" download >
                      Download PDF
                    </a>
                  </td>
                  <td data-cell="created">{moment(detail?.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <Link to={`/enrollment/edit-enrollment/${detail._id}`} className='button-menu-detail'>
                          <EditRounded />
                          <span>Edit Enrollment</span>
                        </Link>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ detailId: detail._id, firstName: detail.firstName }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}

      <Pagination actionGet={actionFetchEnrollmentUsers} page={page} numberOfPages={numberOfPages} totalNumber={totalNumber} />
      </div>
    </>
  )
}

export default ViewEnrollment